import { Text } from "../uikit";
import styles from "./guiderow.module.css";

export default function GuideRow({
  number,
  text,
  action = null,
  code = null,
  actionPaddingLeft = "full",
}) {
  return (
    <div className={styles.container}>
      <div className={styles.data}>
        <Text className={styles.number}>{number}</Text>
        <Text className={styles.text}>{text}</Text>
      </div>
      {action != null && (
        <div
          className={
            styles["action-padding-left-" + actionPaddingLeft] +
            " " +
            styles["action-padding-right"]
          }
        >
          {action}
        </div>
      )}
      {code != null && (
        <div
          className={
            styles["action-padding-left-" + actionPaddingLeft] +
            " " +
            styles["action-padding-right"]
          }
        >
          <div className={styles.pre}>
            <div className={styles.code}>{code}</div>
          </div>
        </div>
      )}
    </div>
  );
}
